import { Component, createRef } from 'react'
import withRouter from '../components/withRouter'
import { API, Storage } from 'aws-amplify'
import { v1 as uuidv1 } from 'uuid'
import { jwtDecode } from 'jwt-decode'
import { pdf, Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer'
import { CiSettings, CiMedicalClipboard } from 'react-icons/ci'
import { FaChevronDown, FaRegQuestionCircle, FaRegEnvelope, FaRegIdCard, FaSignature, FaSearch, FaRegImages, FaHandHoldingMedical, FaClinicMedical } from 'react-icons/fa'
import { FaPeopleRoof, FaPrescription } from 'react-icons/fa6'
import { LuLogOut, LuFileJson2 } from 'react-icons/lu'
import { FaBuildingShield, FaArrowLeft } from 'react-icons/fa6'
import { TfiReload } from 'react-icons/tfi'
import { FcApproval, FcCancel } from 'react-icons/fc'
import { RiHealthBookLine, RiTeamLine } from 'react-icons/ri'
import { TbVaccine, TbReportMedical, TbPhoneCalling, } from 'react-icons/tb'
import { MdOutlineSick, MdOutlineMedication, MdOutlinePermMedia } from 'react-icons/md'
import { LiaFileMedicalAltSolid, LiaProceduresSolid } from 'react-icons/lia'
import { BsPrescription } from 'react-icons/bs'
import moment from 'moment'
import Sharing from '../images/datasharing.png'
import Provider from '../images/provideraccess.png'
import Logo from '../images/hit_logo.png'
import PatientCard from '../components/patientCard'
import Patient from '../components/Patient'
import Encounter from '../components/Encounter'
import Condition from '../components/Condition'
import AllergyIntolerance from '../components/AllergyIntolerance'
import Immunization from '../components/Immunization'
import Practitioner from '../components/Practitioner'
import Organization from '../components/Organization'
import Observation from '../components/Observation'
import Procedure from '../components/Procedure'
import DiagnosticReport from '../components/DiagnosticReport'
import Device from '../components/Device'
import CareTeam from '../components/CareTeam'
import CarePlan from '../components/CarePlan'
import Coverage from '../components/Coverage'
import Appointment from '../components/Appointment'
import MedicationRequest from '../components/MedicationRequest'
import ServiceRequest from '../components/ServiceRequest'
import TBD from '../components/tbd'
import PatientSmall from '../components/PatientSmall'
import { PeriodStart, Names } from '../helpers'
import SignatureHealthLogo from '../images/SignatureHealthLogo.png'
import './datasharing.css'
import './all.css'

class IOP extends Component {
    constructor(props) {
        super(props)
        //Insurers  Payers  Linked Payers Provider Apps
        this.state = {
            menu: '',
            search: '',
            common: [],
            payers: [],
            apps: [],
            splash: true,
            bounce: false,
            payer: null,
            payerConsent: false,
            isOptOut: false,
            provider: false,
            history: [
            ],
            topMenu: null,
            msg: '',
            displayMsg: false,
            isRefreshing: false,
            concurrent: false,
            failed: false,
            denied: false,
            missingPayer: false,
            missingPayers: [],
            mpPayer: '',
            mpUrl: '',
            mpPhone: '',
            mpAddr: '',
            step: 0,
            isWorking: false,
            p2pStatus: null,
            p2pToken: null,
            p2pMbrMatch: null,
            p2pFhirID: null,
            p2pData: null,
            states: ['All', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY'],
            state: 'All',
            patient: '',
            jwt: null,
            pid: null,
            mm: null,
            data: null,
            pretty: false,
            more: [],
            consentDoc: '',
            next: null,
            members: [],
            midx: 0,
            direct: true,
            availity: false,
            availityCatalog: null,
            availitySelected: null,
            accessurl: null,
            scopeurl: null,
            mmurl: null,
            fhirurl: null,
            fail: false
        }
    }

    ScrollDown = createRef()

    //['Anthem', 'Aetna', 'Cigna', 'Humana', 'United Healthcare', 'HCSC', 'Kaiser Permanente', 'CVS Health', 'BCBSAL'],
    componentDidMount() {
        if (this.props.isAuthenticated) {
            setTimeout(() => this.setState({ splash: false }), 1000)
            API.get('hit', 'props?prop=new payers,members')
                .then(resp => {
                    let payers = resp.data.filter(p => p.prop === 'new payers')[0].values
                    let members = resp.data.filter(p => p.prop === 'members')[0].values
                    let pidx = members.length > 0 ? members[0].parameter.findIndex(p => p.name === 'MemberPatient') : -1
                    let patient = pidx > -1 ? Names(members[0].parameter[pidx].resource.name) : 'John Smith'
                    this.setState({
                        common: payers.sort((a, b) => {
                            if (a.cnt > b.cnt) return -1
                            if (a.cnt < b.cnt) return 1
                            return 0
                        }).slice(0, 5),
                        payers,
                        isOptOut: this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut,
                        members,
                        patient
                    })
                })
                .catch(err =>
                    console.log(err)
                )
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('login', true)
            }, 3000)
        }
    }
    scrollToRef = ref => {
        ref.current.scroll({
            top: 200,
            behavior: 'smooth'
        })
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleMenuSelected(menu) {
        this.setState({
            menu,
            topMenu: null,
            direct: true,
            availity: false,
            failed: false,
            denied: false,
            isWorking: false,
            step: 0,
            displayMsg: false,
            p2pToken: null,
            mmurl: null,
            mm: null,
            jwt: null,
            scopeurl: null,
            data: null,
            fhirurl: null,
            fail: false
        })
        this.handleRefresh()
    }

    handleStart() {
        this.setState({ menu: 'Payers', topMenu: null, step: 0 })
    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value.replace(/[<>//]/g, ""), topMenu: null })
    }

    handleCheckChanged(e) {
        if (e.target.value === 'denied') {
            this.setState({ [e.target.value]: e.target.checked, topMenu: null, failed: false })
        } else if (e.target.value === 'failed') {
            this.setState({ [e.target.value]: e.target.checked, topMenu: null, denied: false })
        } else if (e.target.value === 'direct') {
            this.setState({
                [e.target.value]: e.target.checked,
                topMenu: null,
                availity: false,
                failed: false,
                denied: false,
                menu: 'P2P',
                isWorking: false,
                step: 0.1,
                displayMsg: false,
                p2pToken: null,
                mmurl: null,
                mm: null,
                jwt: null,
                scopeurl: null,
                data: null,
                fhirurl: null
            })
        } else if (e.target.value === 'availity') {
            this.setState({
                [e.target.value]: e.target.checked,
                topMenu: null,
                direct: false,
                failed: false,
                denied: false,
                menu: 'P2P',
                isWorking: false,
                step: 0.1,
                displayMsg: false,
                p2pToken: null,
                mmurl: null,
                mm: null,
                jwt: null,
                scopeurl: null,
                data: null,
                fhirurl: null
            })
            if (!this.state.availityCatalog) {
                API.get('hit', 'catalog?source=availity')
                    .then(resp => {
                        const availityCatalog = resp.data && resp.data.payers ? resp.data.payers : []
                        const availitySelected = availityCatalog.findIndex(ac => ac.payerId === 'BCBSF-QA')
                        this.setState({ availityCatalog, availitySelected })
                    })
                    .catch(err =>
                        console.log(err)
                    )
            }
        } else this.setState({ [e.target.value]: e.target.checked, topMenu: null })
    }

    handleSelectChanged(e) {
        this.setState({ [e.target.id]: e.target.value, topMenu: null })
    }

    handlePayerSelected(payer) {
        this.setState({ payer: payer.display, topMenu: null })
    }

    handleMPayerSelected(payer) {
        this.setState({ mpPayer: payer.payer, mpAddr: payer.address || '', mpPhone: payer.phone || '', mpUrl: payer.url || '', topMenu: null })
    }

    handlep2pStart() {
        if (!this.state.payerConsent || !this.state.payer) return false
        this.setState({ topMenu: null })
        if (this.state.payer !== 'Florida Blue') {
            this.handleFetch()
        } else if (this.state.step === 0.1) {
            this.handleFetch()
        } else this.setState({ direct: true, availity: false, failed: false, denied: false, menu: 'P2P', isWorking: false, step: 0.1, fail: false })
    }

    handleReset() {
        this.setState({
            direct: true,
            availity: false,
            failed: false,
            denied: false,
            menu: 'P2P',
            isWorking: false,
            step: 0.1,
            displayMsg: false,
            p2pToken: null,
            mmurl: null,
            mm: null,
            jwt: null,
            scopeurl: null,
            data: null,
            fhirurl: null,
            fail: false
        })
    }

    handleFetch() {
        if (!this.state.payerConsent) return false
        API.get('hit', 'user')
            .then(resp => {
                this.setState({
                    history: resp.data && resp.data.healthIns && resp.data.healthIns.p2p ? [...resp.data.healthIns.p2p, {
                        "date": moment().format('lll'),
                        "type": this.state.concurrent ? 'Concurrent' : 'Previous',
                        "payer": this.state.payer,
                        "requestor": "Self",
                        "status": "Data Transfer Initiated",
                        "target": "Self"
                    }] : []
                })
                let status = this.state.denied ? 'denied' : (this.state.failed ? 'failed' : null)
                if (!status) this.setState({ menu: 'P2P', isWorking: true })
                API.post('hit', this.state.payer === 'Florida Blue' ? 'p2p2' : 'p2p', { body: { type: this.state.concurrent ? 'Concurrent' : 'Previous', payer: this.state.payer, status, availity: this.state.availity ? true : null, fail: this.state.fail } })
                    .then(resp => {
                        if (this.state.payer === 'Florida Blue') {
                            this.setState({ menu: 'P2P', concurrent: false, step: 1, p2pStatus: resp.status, p2pToken: resp.token || null, isWorking: false, accessurl: resp.url || null })
                        } else {
                            this.setState({ menu: 'Linked Payers', msg: resp.status, displayMsg: true, concurrent: false, isWorking: false })
                            setTimeout(() => this.handleRefresh(), 2000)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message || err.description, displayMsg: true })
                    })
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message, displayMsg: true })
            })
    }
    

    handleMemberMatch() {
        this.setState({ isWorking: true })
        const doc = uuidv1() + '.pdf'
        const consentDoc = `https://hit-uploads.s3.us-east-1.amazonaws.com/public/${doc}`
        let members = this.state.members
        let cidx = members[this.state.midx].parameter.findIndex(p => p.name === 'Consent')
        if (cidx > -1) members[this.state.midx].parameter[cidx].resource.sourceReference.reference = consentDoc
        API.post('hit', this.state.payer === 'Florida Blue' ? 'p2p2' : 'p2p', { body: { payer: this.state.payer, step: 1, parameter: members[this.state.midx], token: this.state.p2pToken.access_token, consent: `https://hit-uploads.s3.us-east-1.amazonaws.com/public/${doc}`, availity: this.state.availity ? true : null, fail: this.state.fail } })
            .then(resp => {
                this.handleConsentPDF(doc)
                this.setState({ consentDoc, members })
                const idx = resp.data.parameter ? resp.data.parameter.findIndex(p => p.name === 'MemberIdentifier') : -1
                if (idx > -1) {
                    const pid = resp.data.parameter[idx].valueIdentifier.value.replace('urn:uuid:', '')
                    this.setState({ msg: resp.status, displayMsg: true, step: 2, isWorking: false, pid, mm: resp.data, mmurl: resp.url || null })
                } else this.setState({ msg: resp.status, displayMsg: true, step: 2, isWorking: false, mm: resp.data })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                console.log(err)
                this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message, displayMsg: true, isWorking: false })
            })
    }

    handleScopedToken() {
        this.setState({ isWorking: true })
        API.post('hit', this.state.payer === 'Florida Blue' ? 'p2p2' : 'p2p', { body: { payer: this.state.payer, step: 2, pid: this.state.pid, token: this.state.p2pToken.access_token, availity: this.state.availity ? true : null, fail: this.state.fail } })
            .then(resp => {
                this.setState({ msg: resp.status, displayMsg: true, step: 3, isWorking: false, jwt: resp.data, scopeurl: resp.url || null })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                console.log(err)
                this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message, displayMsg: true, isWorking: false })
            })
    }

    handleFetchEverything() {
        API.post('hit', this.state.payer === 'Florida Blue' ? 'p2p2' : 'p2p', { body: { payer: this.state.payer, step: this.state.next ? 4 : 3, next: this.state.next, token: this.state.p2pToken.access_token, jwt: this.state.jwt.access_token, pid: this.state.pid, availity: this.state.availity ? true : null, fail: this.state.fail } })
            .then(resp => {
                let next = null
                let step = 4
                if (resp.data && resp.data.link) {
                    const lidx = resp.data.link.findIndex(l => l.relation === 'next')
                    if (lidx > -1) {
                        next = resp.data.link[lidx].url
                    } else step = 5
                }
                this.setState({ menu: 'P2P', msg: resp.status, displayMsg: true, step, p2pStatus: resp.status, data: this.state.data ? { ...this.state.data, entry: [...this.state.data.entry, ...resp.data.entry] } : resp.data, next, fhirurl: resp.url || null })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message, displayMsg: true })
            })
    }

    handleP2PDone() {
        API.post('hit', this.state.payer === 'Florida Blue' ? 'p2p2' : 'p2p', { body: { payer: this.state.payer, step: 5, token: this.state.p2pToken.access_token, availity: this.state.availity ? true : null, fail: this.state.fail } })
            .then(resp => {
                this.setState({ msg: resp.status, displayMsg: true, step: 0, p2pStatus: null, data: null, next: null })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                this.setState({ msg: err.response && err.response.data && err.response.data.error ? JSON.stringify(err.response.data.error) : err.message, displayMsg: true })
            })
    }

    handleRefresh() {
        this.setState({ isRefreshing: true })
        API.get('hit', 'user')
            .then(resp => {
                this.setState({
                    history: resp.data && resp.data.healthIns && resp.data.healthIns.p2p ? resp.data.healthIns.p2p : [],
                    apps: resp.data && resp.data.healthIns && resp.data.healthIns.apps ? resp.data.healthIns.apps : [],
                    provider: resp.data && resp.data.healthIns && resp.data.healthIns.provider,
                    consent: (this.state.provider && this.state.provider.consent) || true,
                    isRefreshing: false
                })
                this.props.setUser(resp.data)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
            })
    }

    handleCancelApp(app) {
        this.setState({ isRefreshing: true })
        API.put('hit', 'appcancel', { body: { app } })
            .then(resp => {
                this.setState({ msg: resp.status, displayMsg: true, isRefreshing: false })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
            })
    }

    handleOptOut() {
        if (this.state.isOptOut) {
            API.put('hit', 'providerconsent', { body: { isOptOut: !(this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut) } })
                .then(resp => {
                    this.setState({ msg: resp.status, displayMsg: true, isOptOut: false })
                    setTimeout(() => this.handleRefresh(), 2000)
                })
                .catch(err => {
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('login')
                    } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
                })
        }
    }

    handleTopMenu(topMenu) {
        if (topMenu === this.state.topMenu) this.setState({ topMenu: null })
        else this.setState({ topMenu })
    }

    handleCloseTopMenu() {
        this.setState({ topMenu: null })
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleMissingPayer() {
        if (!this.state.missingPayer) {
            API.get('hit', 'props?prop=missingPayers')
                .then(resp => {
                    let missingPayers = resp.data[0].values.sort((a, b) => {
                        if (a.payer > b.payer) return -1
                        if (a.payer < b.payer) return 1
                        return 0
                    })
                    this.setState({ missingPayers, missingPayer: true })
                })
                .catch(err =>
                    console.log(err)
                )
        } else this.setState({ missingPayer: false })
    }

    handleMissingPayerSubmit() {
        if (this.state.mpPayer) {
            API.post('hit', 'missingpayer', { body: { payer: this.state.mpPayer, url: this.state.mpUrl, phone: this.state.mpPhone, address: this.state.mpAddr } })
                .then(resp => {
                    this.setState({ msg: resp.status, displayMsg: true, mpPayer: '', mpUrl: '', mpPhone: '', mpAddr: '', missingPayer: false })
                })
                .catch(err => {
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('login')
                    } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
                })
        }
    }

    handleStep(next) {
        if (!this.state.isWorking) {
            switch (this.state.step) {
                case 0:
                    this.handlep2pStart()
                    break
                case 0.1:
                    this.handlep2pStart()
                    break
                case 1:
                    this.handleMemberMatch()
                    break
                case 2:
                    this.handleScopedToken()
                    break
                case 3:
                    this.handleFetchEverything()
                    break
                case 4:
                    this.handleFetchEverything()
                    break
                case 5:
                    this.handleP2PDone()
                    this.handleMenuSelected('Linked Payers')
                    this.setState({ data: null, jwt: null, p2pToken: null, pid: null, patient: null, pretty: false })
                    break
                default:
                    this.setState({ menu: 'Payers' })
            }
            setTimeout(() => this.scrollToRef(this.ScrollDown), 250)
        } else this.setState({ menu: 'Payers' })
    }

    handlePretty() {
        this.setState({ pretty: !this.state.pretty })
    }

    handleMore(res) {
        let idx = this.state.more.indexOf(res)
        let more = this.state.more
        if (idx > -1) {
            more.splice(idx, 1)
        } else more.push(res)
        this.setState({ more })
    }

    handleMemberSelect(midx) {
        let pidx = this.state.members[midx].parameter.findIndex(p => p.name === 'MemberPatient')
        let patient = pidx > -1 ? Names(this.state.members[midx].parameter[pidx].resource.name) : this.state.patient
        this.setState({ midx, patient })
    }

    handleCatalogSelected(availitySelected) {
        this.setState({ availitySelected })
    }

    async handleConsentPDF(doc) {
        const styles = StyleSheet.create({
            page: {
                flexDirection: 'row',
                backgroundColor: '#E4E4E4',
            },
            section: {
                margin: 10,
                padding: 10,
                flexGrow: 1,
            },
            image: {
                width: 200,
                height: 70,
                margin: 10
            },
            text1: {
                fontSize: 14,
                fontFamily: 'Helvetica-Bold',
                margin: 10,
                padding: 10,
            },
            text2: {
                fontSize: 12,
                fontFamily: 'Helvetica-Bold',
                margin: 10,
                padding: 10,
            },
            text3: {
                fontSize: 11,
                fontFamily: 'Helvetica',
                margin: 10,
                padding: 10,
            }
        });

        const Consent = () => <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                    <Image style={styles.image} src={SignatureHealthLogo} />
                    <Text style={styles.text1}>Payer to Payer Consent</Text>
                    <Text style={styles.text2}>Consent for Data Exchange from {this.state.availity && this.state.availitySelected && this.state.availitySelected > -1 ? this.state.availityCatalog[this.state.availitySelected].planName : this.state.payer || ''} to Signature Healthplans</Text>
                    <Text style={styles.text3}>The CMS Mandate 0057-F requires Insurance Companies to permit the exchange of a member's clinical and claims data from previous payers to current payers to support patient continuity of care.</Text>
                    <Text style={styles.text2}>On {moment().format('LL')}, {this.state.patient || ''} consents to allow Signature Healthplans to attempt to retrieve the entire health record of {this.state.patient || ''} from {this.state.availity && this.state.availitySelected && this.state.availitySelected > -1 ? this.state.availityCatalog[this.state.availitySelected].planName : this.state.payer || ''}</Text>
                </View>
            </Page>
        </Document>

        const pdfBlob = await pdf(<Consent />).toBlob()
        Storage.put(doc, pdfBlob, {
            contentType: 'application/pdf',
            progressCallback(progress) {
                console.log(`Uploaded: ${progress.loaded}/${progress.total}`)
            }
        })
    }

    getStepText() {
        switch (this.state.step) {
            case 0.1:
                return 'Get Access Token'
            case 1:
                return 'Member Match'
            case 2:
                return 'Patient Scoped Token'
            case 3:
                return 'Fetch P2P Data'
            case 4:
                return 'Fetch Next P2P Data'
            case 5:
                return 'Transfer Complete'
            default:
                return 'Add Payer'
        }
    }

    getMbrMatchResource(idx) {
        let member = this.state.members[idx]
        if (this.state.availity && this.state.availitySelected && this.state.availitySelected > -1) {
            let pidx = member.parameter.findIndex(r => r.name === 'CoverageToMatch')
            if (pidx > -1) {
                member.parameter[pidx].resource.payor = [{ display: this.state.availityCatalog[this.state.availitySelected].payerName, identifier: { system: "https://apigw-stga.bcbsfl.com/interop-stage/interop-developer-portal-stage/hit/p2p-out/api/v1-ext/Patient/$member-match", value: this.state.availityCatalog[this.state.availitySelected].payerId } }]
            }
        }
        return member
    }

    getMessage() {
        return <div className='DS-Confirm'>
            <div className='All-Row All-Text'>{this.state.msg}</div>
            <div className="All-Row All-Flex-Wrap">
                <div className='All-Button All-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getHome() {
        return <div>
            <div>
                <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Available Options</div>
                <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data</div>
                <hr />
                <div className='DS-Box'>
                    <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18pt', borderBottom: '2px solid #000' }}>
                        Current Data Sharing
                    </div>
                    <div className='DS-Flex-Spread'>
                        <div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14pt' }}>
                                App Sharing
                            </div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '11pt' }}>
                                Sharing - {this.props.user && this.props.user.healthIns && this.props.user.healthIns.apps ? this.props.user.healthIns.apps.length : 0} Apps
                            </div>
                        </div>
                        <div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14pt' }}>
                                Provider Sharing Status
                            </div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18pt' }}>
                                {this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut ? <FcCancel /> : <FcApproval />}
                            </div>
                        </div>
                        <div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14pt' }}>
                                Other Insurer Sharing
                            </div>
                            <div className='DS-Row' style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '11pt' }}>
                                Sharing - {this.props.user && this.props.user.healthIns && this.props.user.healthIns.p2p ? this.props.user.healthIns.p2p.length : 0} Insurers
                            </div>
                        </div>
                    </div>
                </div>
                <div className='DS-Flex-Spread'>
                    <div style={{ fontSize: '11pt' }}>
                        <p>Do you have previous or concurrent health insurers? We've made it easy for you to securely access your health history from your other insurers - all from your Florida Blue member account! By having them share this information with us, you can:</p>
                        <ul>
                            <li>Access your health history, with a 5 year lookback from the date we process your request in just one location, making it easier for you to talk to your doctor about your health needs.</li>
                            <li>Get recommendations for custom health and wellness programs.</li>
                            <li>Share data with any provider where there exists a treatment relationship.</li>
                            <li>Track your care journey and take charge of your health.</li>
                            <li>Ready? You may request your data exchange below or by speaking with an agent. To view your current data sharing, <span className='DS-Link' onClick={() => this.handleMenuSelected('Linked Payers')}>Click Here</span>.</li>
                        </ul>
                        <div className='DS-Flex-Spread'>
                            <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleStart()}>Start Now</div>
                            <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px', paddingTop: '0px' }} onClick={() => this.handleMenuSelected('Linked Payers')}>View Requests</div>
                        </div>
                    </div>
                    <div><img src={Sharing} alt="Data Sharing" /></div>
                </div>
                <hr />
                <div className='DS-Flex-Spread'>
                    <div style={{ fontSize: '11pt' }}>
                        <p>Upcoming Doctor's Appointment? We've made it easy for you to securely share your health history with any healthcare provider you have a treatment relationship with. By allowing Provider Access to your medical history, you can:</p>
                        <ul>
                            <li>Kill the Clipboard as your medical professionals will have access to your health data.</li>
                            <li>Inform your provider of any medical risks and history that may be relevant to your visit.</li>
                            <li>Improve your healthcare by informing your provider of any care programs you are participating in.</li>
                        </ul>
                        <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleMenuSelected('Provider')}>Check Status</div>
                    </div>
                    <div><img src={Provider} style={{ width: '186px' }} alt="Data Sharing" /></div>
                </div>
                <hr />
                <div className='DS-Flex-Spread'>
                    <div style={{ fontSize: '11pt' }}>
                        <p>Use your favorite Healthcare App to monitory your data. By allowing 3rd Party Apps access to your medical history, you can:</p>
                        <ul>
                            <li>do stuff.</li>
                        </ul>
                        <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleMenuSelected('Apps')}>Manage Apps</div>
                    </div>
                    <div><img src={Sharing} alt="Data Sharing" /></div>
                </div>
            </div>
        </div>
    }

    getInsurers() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Other Health Insurers</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data</div>
            <hr />
            <div className='DS-Flex-Spread'>
                <div style={{ fontSize: '11pt' }}>
                    <p>Do you have previous or concurrent health insurers? We've made it easy for you to securely access your health history from your other insurers - all from your Florida Blue member account! By having them share this information with us, you can:</p>
                    <ul>
                        <li>Access your health history, with a 5 year lookback from the date we process your request in just one location, making it easier for you to talk to your doctor about your health needs.</li>
                        <li>Get recommendations for custom health and wellness programs.</li>
                        <li>Share data with any provider where there exists a treatment relationship.</li>
                        <li>Track your care journey and take charge of your health.</li>
                        <li>Ready? You may request your data exchange below or by speaking with an agent.</li>
                    </ul>
                    <div className='DS-Flex-Spread'>
                        <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleStart()}>Start Now</div>
                        <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px', paddingTop: '0px' }} onClick={() => this.handleMenuSelected('Linked Payers')}>View Requests</div>
                    </div>
                </div>
                <div><img src={Sharing} alt="Data Sharing" /></div>
            </div>
        </div>
    }

    getProvider() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Provider Data Exchange</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data with Providers</div>
            <hr />
            <div className='DS-Flex-Spread'>
                <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Consent for Authorization</div>
                <div className='DS-Opt-Icon'>{this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut ? <FcCancel /> : <FcApproval />}</div>
            </div>
            <p className='DS-Row DS-Legal'>Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
            </p>
            <div className=''>
                <input value="isOptOut" type="checkbox" checked={this.state.isOptOut} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>{`I have read and understand the implications of Opting ${this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut ? 'In' : 'Out'} of Provider Access Data Exchanges.`}</span>
            </div>
            <div style={{ marginTop: '10px' }}>
                <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleOptOut()}>Submit</div>
            </div>
        </div>
    }

    getMissingPayer() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Other Health Insurers</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Connect to My Other Payer</div>
            <hr />
            <div className='DS-Text'>Please provide us with information to help us Connect to your Other Payer.</div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-TB-Label'>Payer Name</div>
                <input id='mpPayer' className='DS-Textbox' type='text' placeholder='Other Payer Name' value={this.state.mpPayer} onChange={this.handleChange} />
            </div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-TB-Label'>Payer Website</div>
                <input id='mpUrl' className='DS-Textbox' type='text' placeholder='Other Payer URL' value={this.state.mpUrl} onChange={this.handleChange} />
            </div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-TB-Label'>Payer Phone</div>
                <input id='mpPhone' className='DS-Textbox' type='phone' placeholder='Other Payer Phone' value={this.state.mpPhone} onChange={this.handleChange} />
            </div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-TB-Label'>Payer Address</div>
                <input id='mpAddr' className='DS-Textbox' type='text' placeholder='Other Payer Address' value={this.state.mpAddr} onChange={this.handleChange} />
            </div>
            {this.state.mpPayer.length > 0 && <div className='DS-Flex-Wrap'>
                {this.state.missingPayers.filter(payer => (payer.payer || payer.display).toLowerCase().indexOf(this.state.mpPayer.toLowerCase()) > -1).sort((a, b) => {
                    if ((a.payer || a.display) > (b.payer || b.display)) return 1
                    if ((a.payer || a.display) < (b.payer || b.display)) return -1
                    return 0
                }).map((p, pidx) => {
                    return <div key={`mpayer-${pidx}`} className={`DS-Payer${this.state.mpPayer === (p.payer || p.display) ? ' DS-Payer-Selected' : ''}`} onClick={() => this.handleMPayerSelected(p)}><div>{(p.payer || p.display)}</div></div>
                })}
            </div>}
            <div className='DS-Row DS-Flex-Spread'>
                <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handleMissingPayerSubmit()}>Submit</div>
                <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handleMissingPayer()}>Cancel</div>
            </div>
        </div>
    }

    getMissingPayers() {
        let newMP = this.props.user.healthIns.missingPayers.filter(mp => !mp.id)
        let mp = this.props.user.healthIns.missingPayers.filter(mp => mp.id)
        return <div>
            <div className='DS-Row DS-Table-Header'>Missing Payer Requests</div>
            {
                mp.map((p, pidx) => {
                    const cp = this.getCorrelatedPayer(p.id)
                    return <div key={`cmp-${pidx}`} className='DS-Row DS-Table-Row'><span style={{ fontWeight: 'bold' }}>{p.payer}</span>{` was requested to be added for data transfers and is listed as `}<span style={{ fontWeight: 'bold' }}>{cp.display}</span>{` which is currently `}<span style={{ textDecoration: 'underline' }}>{cp.status}</span>.</div>
                })
            }
            {
                newMP.map((n, nidx) => {
                    return <div key={`nmp-${nidx}`} className='DS-Row DS-Table-Row'><span style={{ fontWeight: 'bold' }}>{n.payer}</span>{` was requested to be added for data transfers and is currently `}<span style={{ textDecoration: 'underline' }}>{n.status}</span>.</div>
                })
            }
        </div>
    }

    getCorrelatedPayer(id) {
        const idx = this.state.payers.findIndex(p => p.id === id)
        if (idx > -1) return this.state.payers[idx]
        return { display: "Unknown", status: "Unknown" }
    }

    getPayers() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Other Health Insurers</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data</div>
            <hr />
            <div className='DS-Text'>To get started, select one of the most common insurance providers listed below or look for one by using the search bar.</div>
            <div className='DS-Flex-Spread'>
                <div className='DS-Flex'>
                    <div className='DS-Flex'>
                        <div className='DS-Search-Icon'><FaSearch /></div>
                        <input id='search' className='DS-Search' type='search' placeholder='Search for insurance provider' value={this.state.search} onChange={this.handleChange} />
                    </div>
                    <div style={{ marginLeft: '10px', paddingTop: '15px' }}>
                        <label htmlFor='state' className='DS-TB-Label'>Filter by State</label>
                        <select className='DS-TB-Label' style={{ marginTop: '5px' }} id='state' value={this.state.state} onChange={(event) => this.handleSelectChanged(event)}>
                            {this.state.states.map((s, sidx) => {
                                return <option key={`state-${sidx}`} className='DS-TB-Label' value={s}>{s}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className='DS-Button' style={{ marginTop: '0px', marginBottom: '0px' }} onClick={() => this.handleMissingPayer()}>Missing Payer</div>
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>{this.state.search.length > 0 ? 'Matched Payers' : 'Commonly Used'}</div>
            {!this.state.search.length > 0 && <div className='DS-Flex-Wrap'>
                {this.state.common.map((c, cidx) => {
                    return <div key={`common-${cidx}`} className={`DS-Payer${this.state.payer === c.display ? ' DS-Payer-Selected' : ''}`} onClick={() => this.handlePayerSelected(c)}>{c.display}</div>
                })}
            </div>}
            {this.state.search.length > 0 && <div className='DS-Flex-Wrap'>
                {this.state.payers.filter(pf => this.state.state === 'All' || (pf.states && pf.states.indexOf(this.state.state) > -1)).filter(payer => payer.display.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 || payer.alias.findIndex(a => a.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1) > -1).sort((a, b) => {
                    if (a.display > b.display) return 1
                    if (a.display < b.display) return -1
                    return 0
                }).map((p, pidx) => {
                    let aliases = p.alias.filter(a => a.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1)
                    return <div key={`payer-${pidx}`} className={`DS-Payer${this.state.payer === p.display ? ' DS-Payer-Selected' : ''}`} onClick={() => this.handlePayerSelected(p)}><div>{p.display}</div><ul style={{ fontSize: '8pt' }}>{aliases.map((a, aidx) => <li key={`${p.display}-${aidx}`}>{a}</li>)}</ul></div>
                })}
            </div>}
            <div className=''>
                <input value="concurrent" type="checkbox" checked={this.state.concurrent} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>I have a concurrent plan and would like quarterly updates to my record.</span>
            </div>
            <hr />
            <div className='DS-Flex-Wrap'>
                <div>
                    <input value="denied" type="checkbox" checked={this.state.denied} onChange={(event) => this.handleCheckChanged(event)} />
                    <span className='DS-CB-Text' style={{ fontStyle: 'italic' }}>{`Trigger a Denied Request.`}</span>
                </div>
                <div>
                    <input value="failed" type="checkbox" checked={this.state.failed} onChange={(event) => this.handleCheckChanged(event)} />
                    <span className='DS-CB-Text' style={{ fontStyle: 'italic' }}>{`Trigger a Failed Request.`}</span>
                </div>
            </div>
            <hr />
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Next Steps</div>
            <div className='DS-Text'>
                <ol>
                    <li>{`Check the box below to confirm your consent for Random Payer to connect to ${this.state.payer || 'your other payer.'}`}</li>
                    <li>{`After clicking the "Continue" button, Florida Blue will present your authorization to ${this.state.payer || 'your other payer'} and will attempt to retrieve your records.`}</li>
                    <li>Once your data is retrieved, Random Payer will add your data to your clinical history.</li>
                </ol>
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Consent for Authorization</div>
            <p className='DS-Row DS-Legal'>Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
            </p>
            <div className=''>
                <input value="payerConsent" type="checkbox" checked={this.state.payerConsent} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>I have read and agree to the Priacy & Consent terms for payer data exchange.</span>
            </div>
            <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handlep2pStart()}>Continue</div>
        </div>
    }

    getLinkedInsurance() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>3rd Party Data Sharing</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>My Linked Insurance Providers</div>
            <hr />
            <div className='DS-Text DS-Flex-Spread'><div>Here is a list of the previous and concurrent insurance providers with data sharing requests.</div><div className={`DS-Refresh${this.state.isRefreshing ? ' All-Spin' : ''}`} onClick={() => this.handleRefresh()}><TfiReload /></div></div>
            <div className='DS-Row DS-Table-Header DS-Flex'>
                <div style={{ width: '170px', padding: '5px' }}>Insurer</div>
                <div style={{ width: '120px', padding: '5px' }}>Payer Type</div>
                <div style={{ width: '280px', padding: '5px' }}>Status</div>
                <div style={{ width: '200px', padding: '5px' }}>Date</div>
                <div style={{ width: '100px', padding: '5px' }}></div>
            </div>
            {this.state.history.map((h, hidx) => {
                return <div key={`hist-${hidx}`} className='DS-Row DS-Table-Row DS-Flex'>
                    <div style={{ width: '170px', padding: '5px' }}>{h.payer}</div>
                    <div style={{ width: '120px', padding: '5px' }}>{h.type}</div>
                    <div style={{ width: '280px', padding: '5px' }}>{h.status}</div>
                    <div style={{ width: '200px', padding: '5px' }}>{moment(h.date).format('lll')}</div>
                    {h.type === 'Concurrent' && <div className='DS-Button' style={{ marginTop: '0px', marginBottom: '0px', backgroundColor: 'rgb(18, 91, 186)' }}>Cancel</div>}
                </div>
            })}
            <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handleMenuSelected('Payers')}>Add Payer</div>
            {this.props.user && this.props.user.healthIns && this.props.user.healthIns.missingPayers && this.getMissingPayers()}
        </div>
    }

    getP2P() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>3rd Party Data Sharing</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>My Payer-to-Payer Data Sharing Request</div>
            <hr />
            <div className='DS-Row DS-Flex DS-P2P-Status'>
                Payer to Payer status: <div className='DS-P2P-Status'>{this.state.p2pStatus || this.state.msg}</div>
            </div>
            <hr />
            <div className='DS-Flex-Wrap'>
                <div>
                    <input value="direct" type="checkbox" checked={this.state.direct} onChange={(event) => this.handleCheckChanged(event)} />
                    <span className='DS-CB-Text' style={{ fontStyle: 'italic' }}>{`Direct Connect to Florida Blue.`}</span>
                </div>
                <div>
                    <input value="availity" type="checkbox" checked={this.state.availity} onChange={(event) => this.handleCheckChanged(event)} />
                    <span className='DS-CB-Text' style={{ fontStyle: 'italic' }}>{`${this.state.availitySelected && this.state.availitySelected > -1 ? this.state.availityCatalog[this.state.availitySelected].payerName : 'Other Payer'} Request via Availity Hub.`}</span>
                </div>
            </div>
            {
                this.state.availity && this.getAvailityCatalog()
            }
            {
                this.state.members.length > 0 && <div className='DS-Row DS-Flex-Wrap'>
                    {
                        this.state.members.map((m, midx) => {
                            return <div className={`DS-Member${this.state.midx === midx ? ' DS-Member-Selected' : ''}`} key={`member-${midx}`} onClick={() => this.handleMemberSelect(midx)}>
                                <PatientSmall resource={m.parameter[m.parameter.findIndex(p => p.name === 'MemberPatient')].resource} />
                            </div>
                        })
                    }
                </div>
            }
            {
                this.state.p2pToken && <div className='DS-Row'>
                    <div className='DS-Flex-Spread'>
                        <div className='DS-P2P-Info'>Token Response</div>
                        {this.state.accessurl && <div className='DS-P2P-Url'>{this.state.accessurl}</div>}
                    </div>
                    <pre style={{ fontSize: '10pt' }}>{JSON.stringify(this.state.p2pToken, undefined, 2)}</pre>
                </div>
            }
            {
                this.state.p2pToken && this.state.p2pToken.access_token && <div className='DS-Row'>
                    <div className='DS-P2P-Info'>Decoded Access Token</div>
                    <pre style={{ fontSize: '10pt' }}>{JSON.stringify(jwtDecode(this.state.p2pToken.access_token), undefined, 2)}</pre>
                </div>
            }
            {
                this.state.step >= 1 && <div className='DS-Row'>
                    <div className='DS-Flex-Spread'>
                        <div className='DS-P2P-Info'>Member Match Request</div>
                        {this.state.mmurl && <div className='DS-P2P-Url'>{this.state.mmurl}</div>}
                    </div>
                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12pt' }} className='DS-Row'>
                        <a href={this.state.consentDoc} target="_blank" rel="noreferrer">{this.state.consentDoc.length > 0 ? 'Member Consent' : ''}</a>
                    </div>
                    <pre style={{ maxHeight: '300px', fontSize: '10pt' }}>{JSON.stringify(this.getMbrMatchResource(this.state.midx), undefined, 2)}</pre>
                </div>
            }
            {
                this.state.step >= 1.1 && this.state.mm && <div className='DS-Row'>
                    <div className='DS-P2P-Info'>Member Match Response</div>
                    <pre style={{ maxHeight: '300px', fontSize: '10pt' }}>{JSON.stringify(this.state.mm, undefined, 2)}</pre>
                </div>
            }
            {
                this.state.step >= 2 && this.state.jwt && <div className='DS-Row'>
                    <div className='DS-Flex-Spread'>
                        <div className='DS-P2P-Info'>Scoped Member Token</div>
                        {this.state.scopeurl && <div className='DS-P2P-Url'>{this.state.scopeurl}</div>}
                    </div>
                    <pre style={{ maxHeight: '300px', fontSize: '10pt' }}>{JSON.stringify(this.state.jwt, undefined, 2)}</pre>
                </div>
            }
            {
                this.state.jwt && this.state.jwt.access_token && this.state.jwt.access_token.split('.').length === 3 && <div className='DS-Row'>
                    <div className='DS-P2P-Info'>Decoded Scoped Token</div>
                    <pre style={{ fontSize: '10pt' }}>{JSON.stringify(jwtDecode(this.state.jwt.access_token), undefined, 2)}</pre>
                </div>
            }
            {
                this.state.data && <div className='DS-Row'>
                    <div className='DS-P2P-Info DS-Flex-Spread'>
                        <div className='DS-Flex-Spread'>
                            <div className='DS-P2P-Info'>P2P Data Retrieved</div>
                            {this.state.fhirurl && <div className='DS-P2P-Url'>{this.state.fhirurl}</div>}
                        </div>
                        <div style={{ cursor: 'pointer' }} onClick={() => this.handlePretty()}>{this.state.pretty ? <LuFileJson2 /> : <FaRegImages />}</div>
                    </div>
                    {this.state.pretty ? this.getPatient() : <pre style={{ maxHeight: '300px', fontSize: '10pt' }}>{JSON.stringify(this.state.data, undefined, 2)}</pre>}
                </div>
            }
            {this.state.displayMsg && this.getMessage()}
            <div className='DS-Row DS-Flex-Spread'>
                <div className='DS-Flex-Wrap'>
                    <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px', paddingTop: '0px' }} onClick={() => this.handleStep()}>{this.getStepText()}</div>
                    <div className='DS-Fail'>
                        <input value="fail" type="checkbox" checked={this.state.fail} onChange={(event) => this.handleCheckChanged(event)} />
                        <span className='DS-CB-Text'>Trigger Failure</span>
                    </div>
                </div>
                <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handleReset()}>Reset Demo</div>
            </div>
        </div>
    }

    getApps() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>3rd Party Data Sharing</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>My Linked 3rd Party Apps</div>
            <hr />
            <div className='DS-Text DS-Flex-Spread'><div>Here is a list of the previous and current health applications connections.</div><div className={`DS-Refresh${this.state.isRefreshing ? ' All-Spin' : ''}`} onClick={() => this.handleRefresh()}><TfiReload /></div></div>
            <div className='DS-Row DS-Table-Header DS-Flex'>
                <div style={{ width: '170px', padding: '5px' }}>Application</div>
                <div style={{ width: '170px', padding: '5px' }}>Requestor</div>
                <div style={{ width: '130px', padding: '5px' }}>Status</div>
                <div style={{ width: '200px', padding: '5px' }}>Date</div>
            </div>
            {this.state.apps.map((a, aidx) => {
                return <div key={`hist-${aidx}`} className='DS-Row DS-Table-Row DS-Flex'>
                    <div style={{ width: '170px', padding: '5px' }}>{a.app}</div>
                    <div style={{ width: '170px', padding: '5px' }}>{a.requestor}</div>
                    <div style={{ width: '130px', padding: '5px' }}>{a.active ? 'Active' : 'Inactive'}</div>
                    <div style={{ width: '200px', padding: '5px' }}>{moment(a.date).format('lll')}</div>
                    {a.active && <div className='DS-Button' onClick={() => this.handleCancelApp(a.app)}>Revoke</div>}
                </div>
            })}
        </div>
    }

    getSplash() {
        return <div className='All-Splash'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
        </div>
    }

    getBounce() {
        return <div className='All-Bounce'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
            <div className='All-Content'>Become part of Interoperability by Logging In or Joining HIT FHIR.</div>
        </div>
    }

    getTopMenu() {
        switch (this.state.topMenu) {
            case 'settings':
                return <div className='DS-Top-SubMenu' onClick={() => this.handleCloseTopMenu()}>
                    <div className='DS-Top-Menu-Category'>Contrast Accessibility</div>
                    <div className='DS-Top-Menu-Option'>High Contrast</div>
                    <div className='DS-Top-Menu-Option'>Normal Contrast</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Low Contrast</div>
                    <div className='DS-Top-Menu-Category'>Animation Control</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Turn Off Animations</div>
                    <div className='DS-Top-Menu-Category'>Contact & Help</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Contact Us</div>
                </div>
            case 'myplan':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Costs & Financials</div>
                            <div className='DS-Top-Menu-Option'>Savings Accounts & Rebates</div>
                            <div className='DS-Top-Menu-Option'>Compare Prescription Costs</div>
                            <div className='DS-Top-Menu-Option'>Medical Cost Ranges</div>
                            <div className='DS-Top-Menu-Option'>My Health Statements</div>
                            <div className='DS-Top-Menu-Option'>Blue365 Discount Programs</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Coverage</div>
                            <div className='DS-Top-Menu-Option'>Coverage Breakdown</div>
                            <div className='DS-Top-Menu-Option'>Plan Use</div>
                            <div className='DS-Top-Menu-Option'>Pharmacy Resources</div>
                            <div className='DS-Top-Menu-Option'>Documents & Forms</div>
                        </div>
                    </div>
                </div>
            case 'myclaims':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Claims</div>
                            <div className='DS-Top-Menu-Option'>My Claims</div>
                            <div className='DS-Top-Menu-Option'>Submit a Claim</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Appeals</div>
                            <div className='DS-Top-Menu-Option'>My Appeals</div>
                            <div className='DS-Top-Menu-Option'>Submit an Appeal</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Authorizations</div>
                            <div className='DS-Top-Menu-Option'>My Authorizations</div>
                            <div className='DS-Top-Menu-Option'>Preapproved Authorizations</div>
                        </div>
                    </div>
                </div>
            case 'findcare':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Find Care</div>
                            <div className='DS-Top-Menu-Option'>Find a Doctor & More</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Get Care</div>
                            <div className='DS-Top-Menu-Option'>My Care Team</div>
                            <div className='DS-Top-Menu-Option'>Connect with Care Programs & Resources</div>
                            <div className='DS-Top-Menu-Option'>Better You Strides</div>
                        </div>
                    </div>
                </div>
            default:
                return null
        }
    }

    getIcon(res) {
        switch (res) {
            case 'CarePlan':
                return <RiHealthBookLine />
            case 'CareTeam':
                return <RiTeamLine />
            case 'Condition':
                return <MdOutlineSick />
            case 'ClinicalImpression':
                return <FaHandHoldingMedical />
            case 'Communication':
                return <TbPhoneCalling />
            case 'DiagnosticReport':
                return <TbReportMedical />
            case 'Encounter':
                return <FaPeopleRoof />
            case 'Immunization':
                return <TbVaccine />
            case 'Media':
                return <MdOutlinePermMedia />
            case 'Medication':
                return <MdOutlineMedication />
            case 'MedicationRequest':
                return <FaPrescription />
            case 'MedicationDispense':
                return <BsPrescription />
            case 'Observation':
                return <CiMedicalClipboard />
            case 'Procedure':
                return <LiaProceduresSolid />
            case 'ServiceRequest':
                return <LiaFileMedicalAltSolid />
            default:
                return <FaClinicMedical />
        }
    }

    getPatient() {
        if (this.state.data && this.state.data.entry) {
            let resources = {}
            this.state.data.entry.forEach(res => {
                if (resources[res.resource.resourceType]) {
                    resources[res.resource.resourceType].push(res.resource)
                } else {
                    resources[res.resource.resourceType] = [res.resource]
                }
                if (resources.Encounter) resources.Encounter = resources.Encounter.sort((a, b) => {
                    let x = PeriodStart(a.period)
                    let y = PeriodStart(b.period)
                    if (x > y) return -1
                    if (y > x) return 1
                    return 0
                })
            })
            return <div>
                {
                    resources.Patient && resources.Patient.map((p, pidx) => {
                        return <Patient key={`patient-${pidx}`} resource={p} />
                    })
                }
                {
                    Object.keys(resources).filter(r => r !== 'Patient').sort((a, b) => {
                        if (a > b) return 1
                        if (b > a) return -1
                        return 0
                    }).map((res, residx) => {
                        return <div key={`res-${residx}`}>
                            <div className='All-Row All-Flex-Left'>
                                <div className='All-Divider-Text'><span style={{ marginRight: '5px' }}>{this.getIcon(res)}</span>{res}</div>
                                <div className='All-Divider'></div>
                                <div className='All-Divider-Button' onClick={() => this.handleMore(res)}>{this.state.more.indexOf(res) > -1 ? 'More' : 'Less'}</div>
                            </div>
                            {
                                this.state.more.indexOf(res) === -1 && <div className='All-Row All-Flex-Wrap'>
                                    {
                                        resources[res].map((r, ridx) => {
                                            switch (res) {
                                                case 'AllergyIntolerance':
                                                    return <AllergyIntolerance key={`${res}-${ridx}`} resource={r} />
                                                case 'Appointment':
                                                    return <Appointment key={`${res}-${ridx}`} resource={r} />
                                                case 'DiagnosticReport':
                                                    return <DiagnosticReport key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                case 'Encounter':
                                                    return <Encounter key={`${res}-${ridx}`} resource={r} onSelect={this.handleGetEncounter} />
                                                case 'CarePlan':
                                                    return <CarePlan key={`${res}-${ridx}`} resource={r} />
                                                case 'CareTeam':
                                                    return <CareTeam key={`${res}-${ridx}`} resource={r} />
                                                case 'Condition':
                                                    return <Condition key={`${res}-${ridx}`} resource={r} />
                                                case 'Coverage':
                                                    return <Coverage key={`${res}-${ridx}`} resource={r} />
                                                case 'Device':
                                                    return <Device key={`${res}-${ridx}`} resource={r} />
                                                case 'Immunization':
                                                    return <Immunization key={`${res}-${ridx}`} resource={r} />
                                                case 'MedicationRequest':
                                                    return <MedicationRequest key={`${res}-${ridx}`} resource={r} />
                                                case 'Observation':
                                                    return <Observation key={`${res}-${ridx}`} resource={r} />
                                                case 'Organization':
                                                    return <Organization key={`${res}-${ridx}`} resource={r} />
                                                case 'Patient':
                                                    return <PatientCard key={`${res}-${ridx}`} resource={r} />
                                                case 'Practitioner':
                                                    return <Practitioner key={`${res}-${ridx}`} resource={r} />
                                                case 'Procedure':
                                                    return <Procedure key={`${res}-${ridx}`} resource={r} />
                                                case 'ServiceRequest':
                                                    return <ServiceRequest key={`${res}-${ridx}`} resource={r} />
                                                default:
                                                    return <TBD key={`${res}-${ridx}`} resource={r} />
                                            }
                                        })
                                    }
                                </div>
                            }
                        </div>
                    })
                }
            </div>
        }
    }

    getAvailityCatalog() {
        return this.state.availityCatalog ? <div className='DS-Row DS-Flex-Wrap'>
            {this.state.availityCatalog.map((ac, acidx) => {
                return <div key={`ac-${acidx}`} className={`DS-Payer${acidx === this.state.availitySelected ? ' DS-Payer-Selected' : ''}`} style={{ border: '2px solid #140856', backgroundColor: 'rgb(182 174 229)', color: '#fff', textShadow: '0 0 3px #000' }} onClick={() => this.handleCatalogSelected(acidx)}>
                    <div>{ac.payerName}</div>
                    <div style={{ fontSize: '9pt' }}>{ac.payerDescription}</div>
                </div>
            })}
        </div> : null
    }

    render() {
        //console.log(this.state)
        //console.log(window.innerWidth)
        return this.state.bounce ? this.getBounce() : <div className='DS-Container'>
            <div className='DS-Row DS-Flex-Spread DS-Top-Menu'>
                <div className='DS-Flex'>
                    <div>
                        <div className={`DS-Flex${this.state.topMenu === 'settings' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('settings')}>
                            <div style={{ marginRight: '5px', fontSize: '16pt' }}><CiSettings /></div>
                            <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                        </div>
                        {this.state.topMenu === 'settings' && this.getTopMenu()}
                    </div>
                    <div style={{ paddingLeft: '5px' }}>
                        <div className='DS-Flex'>
                            <div>Espanol</div>
                        </div>
                    </div>
                </div>
                <div className='DS-Flex'>
                    <div>
                        <div className='DS-Flex' style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px' }}>
                            <div style={{ marginRight: '5px' }}><FaRegQuestionCircle /></div>
                            <div>Help</div>
                        </div>
                    </div>
                    <div style={{ paddingLeft: '5px' }}>
                        <div className='DS-Flex'>
                            <div style={{ marginRight: '5px' }}><LuLogOut /></div>
                            <div>Log out</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='DS-Row DS-Flex-Spread DS-Top-Menu-2'>
                <div className='DS-Logo'><div style={{ marginTop: '-2px' }} className='DS-Flex-Wrap'><FaSignature /><FaBuildingShield /></div></div>
                {window.innerWidth > 400 ? <div className='DS-Flex-Spread DS-Top-Menue-Middle'>
                    <div className={`DS-Flex${this.state.topMenu === 'myplan' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('myplan')}>
                        <div style={{ marginRight: '5px' }}>My Plan</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className={`DS-Flex${this.state.topMenu === 'myclaims' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('myclaims')}>
                        <div style={{ marginRight: '5px' }}>My Claims</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className='DS-Flex' style={{ paddingTop: '7px', marginRight: '10px' }}>
                        <div style={{ marginRight: '5px' }}>My Rewards</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className={`DS-Flex${this.state.topMenu === 'findcare' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('findcare')}>
                        <div style={{ marginRight: '5px' }}>Find & Get Care</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                </div> : null}
                {this.state.topMenu === 'myplan' && this.getTopMenu()}
                {this.state.topMenu === 'myclaims' && this.getTopMenu()}
                {this.state.topMenu === 'findcare' && this.getTopMenu()}
                {this.state.displayMsg && this.getMessage()}
                <div>
                    <div className='DS-Flex' style={{ paddingTop: '0px' }}>
                        <div className='DS-Flex' style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px' }}>
                            <div className='DS-Top-Menu-Item' style={{ paddingRight: '5px' }}>
                                <div style={{ marginRight: '5px' }}><FaRegEnvelope /></div>
                                <div style={{ fontSize: '8pt' }}>Messages</div>
                            </div>
                            <div className='DS-Top-Menu-Item' style={{ paddingRight: '5px' }}>
                                <div style={{ marginRight: '5px' }}><FaRegIdCard /></div>
                                <div style={{ fontSize: '8pt' }}>ID Card</div>
                            </div>
                        </div>
                        <div style={{ paddingLeft: '5px' }} className='DS-Flex'>
                            <div style={{ marginRight: '5px' }}>
                                <div style={{ fontWeight: 'bold' }}>{this.props.user ? `${this.props.user.firstName + ' ' || ''}${this.props.user.lastName || ''}` : 'Member Name'}</div>
                                <div style={{ fontSize: '8pt' }}>{this.props.user ? `${this.props.user.healthIns && this.props.user.healthIns.plan ? (this.props.user.healthIns.plan.length > 25 ? `${this.props.user.healthIns.plan.substring(0, 22)}...` : this.props.user.healthIns.plan) : 'Member Plan'}` : 'Member Plan'}</div>
                            </div>
                            <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-Left-Column'>
                    <div className='DS-Menu-Item DS-Flex' onClick={() => this.handleNavigate('', false)}>
                        <div style={{ marginRight: '5px' }}><FaArrowLeft /></div>
                        <div>My Account</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === '' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('')}>
                        <div>Data Sharing Home</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Apps' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Apps')}>
                        <div>Third Party Apps</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Insurers' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Insurers')}>
                        <div>Other Health Insurers</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Provider' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Provider')}>
                        <div>Provider Data Access</div>
                    </div>
                </div>
                <div className='DS-Right-Column'>
                    {this.state.menu === '' && this.getHome()}
                    {this.state.menu === 'Apps' && this.getApps()}
                    {this.state.menu === 'Insurers' && this.getInsurers()}
                    {this.state.menu === 'Payers' && !this.state.missingPayer && this.getPayers()}
                    {this.state.menu === 'Payers' && this.state.missingPayer && this.getMissingPayer()}
                    {this.state.menu === 'Linked Payers' && this.getLinkedInsurance()}
                    {this.state.menu === 'Provider' && this.getProvider()}
                    {this.state.menu === 'P2P' && this.getP2P()}
                </div>
            </div>
            <div ref={this.ScrollDown} className='DS-Row'></div>
        </div>
    }

}
export default withRouter(IOP)